<template>
  <div class="intendedPatientList">
    <!-- 顶部信息 -->
    <div class="header">
      <div class="today">
        <div class="today_title">今日数据</div>
        <div class="today_content">
          <div :class="{ 'today_content_item': true, 'item_active': headerActive === 'today_total' }" @click="changeHeaderActive('today_total')">
            <div class="today_content_item_num">{{ headerTotalMap.inputTotalToday }}</div>
            <div class="today_content_item_title">录入总数</div>
          </div>
          <div class="today_content_line"></div>
          <div :class="{ 'today_content_item': true, 'item_active': headerActive === 'today_friend' }" @click="changeHeaderActive('today_friend')">
            <div class="today_content_item_num">{{ headerTotalMap.addWechatTotalToday }}</div>
            <div class="today_content_item_title">加上好友</div>
          </div>
          <div class="today_content_line"></div>
          <div :class="{ 'today_content_item': true, 'item_active': headerActive === 'today_customerResources' }" @click="changeHeaderActive('today_customerResources')">
            <div class="today_content_item_num">{{ headerTotalMap.validTotalToday }}</div>
            <div class="today_content_item_title">有效客资</div>
          </div>
        </div>
      </div>
      <div class="history">
        <div class="history_title">近30天数据</div>
        <div class="history_content">
          <div :class="{ 'history_content_item': true, 'item_active': headerActive === 'history_total' }" @click="changeHeaderActive('history_total')">
            <div class="history_content_item_num">{{ headerTotalMap.inputTotal30 }}</div>
            <div class="history_content_item_title">录入总数</div>
          </div>
          <div class="history_content_line"></div>
          <div :class="{ 'history_content_item': true, 'item_active': headerActive === 'history_friend' }" @click="changeHeaderActive('history_friend')">
            <div class="history_content_item_num">{{ headerTotalMap.addWechatTotal30 }}</div>
            <div class="history_content_item_title">加上好友</div>
          </div>
          <div class="history_content_line"></div>
          <div :class="{ 'history_content_item': true, 'item_active': headerActive === 'history_customerResources' }" @click="changeHeaderActive('history_customerResources')">
            <div class="history_content_item_num">{{ headerTotalMap.validTotal30 }}</div>
            <div class="history_content_item_title">有效客资</div>
          </div>
          <div class="history_content_line"></div>
          <div class="history_content_converted" @click="changeHeaderActive('history_converted')">
            <div :class="{ 'history_converted_info': true, 'item_active': headerActive === 'history_converted' }">
              <div class="history_converted_info_num">{{ headerTotalMap.convert30 }}</div>
              <div class="history_converted_info_title">已转化</div>
            </div>
            <div class="history_converted_progress" :style="{ '--percentage': Math.round(headerTotalMap.convertRate30 * 100) }">
              <div class="history_converted_progress_text">
                <div class="history_converted_progress_text_num">{{ Math.round(headerTotalMap.convertRate30 * 100) }}%</div>
                <div class="history_converted_progress_text_name">转化率</div>
              </div>
            </div>
          </div>
          <div class="history_content_line"></div>
          <div :class="{ 'history_content_item': true, 'item_active': headerActive === 'history_unconverted' }" @click="changeHeaderActive('history_unconverted')">
            <div class="history_content_item_num">{{ headerTotalMap.maintainTotal30 }}</div>
            <div class="history_content_item_title">未转化</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 操作栏 -->
    <div class="operation">
      <el-button class="operation_add" type="primary" icon="el-icon-plus" @click="toEdit()">新增</el-button>
      <el-button class="operation_filter" plain icon="el-icon-s-operation" @click="filterOpen">筛选</el-button>
    </div>
    <!-- 表格 -->
    <div class="list">
      <el-table class="list_table" :data="list">
        <el-table-column label="序号" type="index" width="50" :index="tableIndexMethod"></el-table-column>
        <el-table-column label="状态" min-width="240px">
          <template slot-scope="scope">
            <div class="table_tag_box">
              <el-tag v-if="['', null, undefined].includes(scope.row.patientPhone)" class="table_tag" type="warning">待补充电话</el-tag>
              <el-tag v-if="['', null, undefined, 0].includes(scope.row.isAddWechat) || ['', null, undefined, 0].includes(scope.row.isValid)" class="table_tag" type="">待完善联系情况</el-tag>
              <el-tag v-if="scope.row.convertStat === 1" class="table_tag" type="info">未转化</el-tag>
              <el-tag v-if="scope.row.convertStat === 2" class="table_tag" type="success">已转化</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="微信号" property="patientWechat" min-width="150px">
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.patientWechat) ? '-' : scope.row.patientWechat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="电话" property="patientPhone" min-width="150px">
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.patientPhone) ? '-' : scope.row.patientPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="意向医生" property="doctorName" min-width="150px">
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.doctorName) ? '-' : scope.row.doctorName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="咨询问题" property="question" min-width="220px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.question) ? '-' : scope.row.question }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" property="remark" min-width="180px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.remark) ? '-' : scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数据有效性" property="isValid" min-width="100px">
          <template slot-scope="scope">
            <span v-if="[null, undefined, '', 0].includes(scope.row.isValid)">-</span>
            <span v-if="scope.row.isValid === 1">无效</span>
            <span v-if="scope.row.isValid === 2">有效</span>
          </template>
        </el-table-column>
        <el-table-column label="添加微信" property="isAddWechat" min-width="80px">
          <template slot-scope="scope">
            <span v-if="[null, undefined, '', 0].includes(scope.row.isAddWechat)">-</span>
            <span v-if="scope.row.isAddWechat === 1">未加上</span>
            <span v-if="scope.row.isAddWechat === 2">已加上</span>
          </template>
        </el-table-column>
        <el-table-column label="沟通情况" property="communication" min-width="220px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.communication) ? '-' : scope.row.communication }}</span>
          </template>
        </el-table-column>
        <el-table-column label="行为结果" property="name" min-width="120px">
          <template slot-scope="scope">
            <span v-if="[null, undefined, ''].includes(scope.row.convertTyp)">-</span>
            <span v-if="scope.row.convertTyp === 1">已挂号</span>
            <span v-if="scope.row.convertTyp === 2">网诊</span>
          </template>
        </el-table-column>
        <el-table-column label="转化时间" property="createTime" min-width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.convertTime && new Date(scope.row.convertTime).Format('yyyy-MM-dd hh:mm:ss') || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运营人员" property="operatorUserName" min-width="150px">
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.operatorUserName) ? '-' : scope.row.operatorUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道" property="channelName" min-width="150px">
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.channelName) ? '-' : scope.row.channelName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="咨询人员" property="consultUserName" min-width="150px">
          <template slot-scope="scope">
            <span>{{ [null, undefined, ''].includes(scope.row.consultUserName) ? '-' : scope.row.consultUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="线索时间" property="inputDate" min-width="120px">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.inputDate).Format('yyyy-MM-dd') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" property="createTime" min-width="160px">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="toDetail(scope.row.id)">详情</el-button>
            <el-button v-if="scope.row.convertStat === 1 || (scope.row.convertStat === 2 && (['', null, undefined, 0].includes(scope.row.isAddWechat) || ['', null, undefined, 0].includes(scope.row.isValid)))" type="text" size="small" @click.native.prevent="toEdit(scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="pageNo"
        :page-size="10"
        :total="total"
        @current-change="pageNoChange">
      </el-pagination>
    </div>
    <el-dialog
      title="筛选"
      :visible.sync="filterMap.visible"
      width="450px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="filterClose">
      <div>
        <el-form ref="filterForm" :rules="filterMap.rules" :model="filterMap.form" label-width="100px">
          <el-form-item label="创建时间：" prop="dateType" required :show-message="false" class="filterForm_item_dateType">
            <el-radio-group v-model="filterMap.form.dateType" @input="dateTypeChange">
              <el-radio label="7day">近7天</el-radio>
              <el-radio label="30day">近30天</el-radio>
              <el-radio label="custom">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="filterMap.form.dateType === 'custom'" label="时间范围：" prop="date" class="filterForm_item_date">
            <el-date-picker
              class="filterForm_input"
              v-model="filterMap.form.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :editable="false"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="意向患者：" prop="patientPhoneOrWechat">
            <el-input class="filterForm_input" v-model.trim="filterMap.form.patientPhoneOrWechat" clearable placeholder="微信/电话"></el-input>
          </el-form-item>
          <el-form-item label="运营人员：" prop="operatorUserId">
            <el-select class="filterForm_input" v-model.trim="filterMap.form.operatorUserId" clearable filterable remote :remote-method="remoteOperatorUserList" placeholder="请选择">
              <el-option v-for="item in filterMap.operatorUserList" :key="item.userId" :label="item.nickName" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拓客渠道：" prop="channelCode">
            <el-cascader class="filterForm_input" v-model.trim="filterMap.form.channelCode" clearable :options="filterMap.channelList" :props="{ label: 'channelName', value: 'channelVal', children: 'items', emitPath: false }" placeholder="请选择" :show-all-levels="false"></el-cascader>
          </el-form-item>
          <el-form-item label="患者状态：" prop="status">
            <el-select class="filterForm_input" v-model.trim="filterMap.form.status" clearable multiple placeholder="请选择">
              <el-option v-for="(item, index) in filterMap.patientStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="filterClose">取 消</el-button>
        <el-button type="primary" @click="filterSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**  
   * headerActive(顶部激活枚举)
   * 
   * today_total: 今日录入总数
   * today_friend: 今日加上好友
   * today_customerResources: 今日有效客资
   * history_total: 近30天录入总数
   * history_friend: 近30天加上好友
   * history_customerResources: 近30天有效客资
   * history_converted: 近30天已转化
   * history_unconverted: 近30天未转化
   */
  import { getChannelList, getSysUserList, getIntentTotal, getIntentList } from "@/api/operation"
  export default {
    name: 'intendedPatientList',
    data () {
      return {
        headerActive: 'history_total',
        headerTotalMap: {
          inputTotalToday: 0,
          addWechatTotalToday: 0,
          validTotalToday: 0,
          inputTotal30: 0,
          addWechatTotal30: 0,
          validTotal30: 0,
          convert30: 0,
          convertRate30: 0,
          maintainTotal30: 0
        },
        filterMap: {
          visible: false,
          channelList: [],
          operatorUserList: [],
          patientStatusList: [
            { label: '待补充电话', value: 'needAddPhone' },
            { label: '待完善联系情况', value: 'needContact' },
            { label: '未转化', value: 'unconverted' },
            { label: '已转化', value: 'converted' }
          ],
          rules: {
            date: [{ required: true, message: '请选择日期', trigger: 'change' }]
          },
          form: {
            patientPhoneOrWechat: '',
            dateType: '', // 7day, 30day, custom
            date: [],
            operatorUserId: '',
            channelCode: '',
            status: []
          }
        },
        listOptionsMap: {
          startDate: '',
          endDate: '',
          isValid: '',
          isAddWechat: '',
          convertStat: '',
          patientPhoneOrWechat: '',
          operatorUserId: '',
          channelCode: '',
          needAddPhone: '',
          needContact: ''
        },
        pageNo: 1,
        list: [],
        total: 0
      }
    },
    methods: {
      async getChannelList () {
        const res = await getChannelList()
        if (res.code == 200) {
          this.filterMap.channelList = res.data
        }
      },
      async getIntentTotal () {
        const res = await getIntentTotal()
        if  (res.code === 200) {
          Object.keys(this.headerTotalMap).forEach(key => {
            this.headerTotalMap[key] = res.data[key]
          })
        } else {
          this.$message.error(res.msg)
        }
      },
      changeHeaderActive (active) {
        this.headerActive = active;
        const today = new Date().Format('yyyy-MM-dd')
        const last_30day = new Date(new Date().setDate(new Date().getDate() - 29)).Format('yyyy-MM-dd')
        let newMap = {
          startDate: '',
          endDate: '',
          isValid: '',
          isAddWechat: '',
          convertStat: '',
          patientPhoneOrWechat: '',
          operatorUserId: '',
          channelCode: '',
          needAddPhone:'',
          needContact: ''
        }
        switch (active) {
          case 'today_total':
            newMap.startDate = today
            newMap.endDate = today
            break;
          case 'today_friend':
            newMap.startDate = today
            newMap.endDate = today
            newMap.isAddWechat = '2'
            break;
          case 'today_customerResources':
            newMap.startDate = today
            newMap.endDate = today
            newMap.isValid = '2'
            break;
          case 'history_total':
            newMap.startDate = last_30day
            newMap.endDate = today
            break;
          case 'history_friend':
            newMap.startDate = last_30day
            newMap.endDate = today
            newMap.isAddWechat = '2'
            break;
          case 'history_customerResources':
            newMap.startDate = last_30day
            newMap.endDate = today
            newMap.isValid = '2'
            break;
          case 'history_converted':
            newMap.startDate = last_30day
            newMap.endDate = today
            newMap.convertStat = '2'
            break;
          case 'history_unconverted':
            newMap.startDate = last_30day
            newMap.endDate = today
            newMap.convertStat = '1'
            break;
        }
        this.listOptionsMap = newMap
        this.pageNo = 1
        this.getList()
      },
      async remoteOperatorUserList (query) {
        const res = await getSysUserList({ searchKey: query })
        if (res.code == 200) {
          this.filterMap.operatorUserList = res.data
        }
      },
      dateTypeChange (type) {
        const today = new Date().Format('yyyy-MM-dd')
        const last_7day = new Date(new Date().setDate(new Date().getDate() - 6)).Format('yyyy-MM-dd')
        const last_30day = new Date(new Date().setDate(new Date().getDate() - 29)).Format('yyyy-MM-dd')
        switch (type) {
          case '7day':
            this.filterMap.form.date = [last_7day, today]
            break;
          case '30day':
            this.filterMap.form.date = [last_30day, today]
            break;
          case 'custom':
            this.filterMap.form.date = []
            this.$nextTick(() => {
              this.$refs['filterForm'].clearValidate('date')
            })
            break;
        }
      },
      filterOpen () {
        this.filterMap.visible = true

        if (window.sessionStorage.getItem('intendPatientFilter')) {
          const intendPatientFilter = JSON.parse(window.sessionStorage.getItem('intendPatientFilter'))
          this.filterMap.form.patientPhoneOrWechat = intendPatientFilter.patientPhoneOrWechat
          this.filterMap.form.operatorUserId = intendPatientFilter.operatorUserId
          this.filterMap.form.channelCode = intendPatientFilter.channelCode
          this.filterMap.form.status = intendPatientFilter.status
          this.filterMap.form.dateType = intendPatientFilter.dateType
          if (intendPatientFilter.dateType === 'custom') {
            this.filterMap.form.date = [intendPatientFilter.startDate, intendPatientFilter.endDate]
          } else {
            this.dateTypeChange(intendPatientFilter.dateType)
          }
        } else {
          this.filterMap.form.patientPhoneOrWechat = ''
          this.filterMap.form.operatorUserId = ''
          this.filterMap.form.channelCode = ''
          this.filterMap.form.status = []
          this.filterMap.form.dateType = '7day'
          this.dateTypeChange('7day')
        }

        this.$nextTick(() => {
          this.$refs['filterForm'].clearValidate()
        })
      },
      filterClose () {
        this.filterMap.visible = false
      },
      filterSubmit () {
        this.$refs['filterForm'].validate(valid => {
          if (valid) {
            let newMap = {
              startDate: '',
              endDate: '',
              isValid: '',
              isAddWechat: '',
              convertStat: '',
              patientPhoneOrWechat: '',
              operatorUserId: '',
              channelCode: '',
              needAddPhone:'',
              needContact: ''
            }
            newMap.patientPhoneOrWechat = this.filterMap.form.patientPhoneOrWechat
            newMap.startDate = this.filterMap.form.date[0]
            newMap.endDate = this.filterMap.form.date[1]
            newMap.operatorUserId = this.filterMap.form.operatorUserId
            newMap.channelCode = this.filterMap.form.channelCode
            newMap.needAddPhone = this.filterMap.form.status.includes('needAddPhone') ? 1 : 0
            newMap.needContact = this.filterMap.form.status.includes('needContact') ? 1 : 0

            const unconverted = this.filterMap.form.status.includes('unconverted')
            const converted = this.filterMap.form.status.includes('converted')
            if ((unconverted || converted) && !(unconverted && converted)) {
              newMap.convertStat = converted ? 2 : 1
            }

            this.listOptionsMap = newMap

            const intendPatientFilter = {
              patientPhoneOrWechat: this.filterMap.form.patientPhoneOrWechat,
              operatorUserId: this.filterMap.form.operatorUserId,
              channelCode: this.filterMap.form.channelCode,
              status: this.filterMap.form.status,
              dateType: this.filterMap.form.dateType,
              startDate: this.filterMap.form.date[0],
              endDate: this.filterMap.form.date[1]
            }
            window.sessionStorage.setItem('intendPatientFilter', JSON.stringify(intendPatientFilter))

            this.headerActive = ''
            this.pageNo = 1
            this.getList()
            this.filterClose();
          }
        })
      },
      tableIndexMethod (index) {
        return (this.pageNo - 1) * 10 + index + 1;
      },
      async getList () {
        const res = await getIntentList({
          ...this.listOptionsMap,
          pageNum: this.pageNo,
          pageSize: 10
        })
        if (res.code === 200) {
          this.list = res.data.items;
          this.total = res.data.totalNum;
        } else {
          this.$message.error(res.msg)
        }
      },
      pageNoChange (val) {
        this.pageNo = val;
        this.getList();
      },
      saveFilter () {
        const intendPatientInfo = {
          ...this.listOptionsMap,
          headerActive: this.headerActive,
          pageNo: this.pageNo
        }
        window.sessionStorage.setItem('intendPatientInfo', JSON.stringify(intendPatientInfo))
      },
      toEdit (id) {
        this.saveFilter()
        const url = id ? `/patient/intendedPatient/edit/${id}` : '/patient/intendedPatient/edit'
        this.$router.push(url)
      },
      toDetail (id) {
        this.saveFilter()
        this.$router.push(`/patient/intendedPatient/detail/${id}`)
      },
    },
    async created () {
      this.getChannelList()
      this.getIntentTotal()
      if (window.sessionStorage.getItem('intendPatientInfo')) {
        const intendPatientInfo = JSON.parse(window.sessionStorage.getItem('intendPatientInfo'))
        Object.keys(this.listOptionsMap).forEach(key => {
          this.listOptionsMap[key] = intendPatientInfo[key]
        })
        this.headerActive = intendPatientInfo.headerActive
        this.pageNo = intendPatientInfo.pageNo
        window.sessionStorage.removeItem('intendPatientInfo')
      } else {
        const today = new Date().Format('yyyy-MM-dd')
        const last_30day = new Date(new Date().setDate(new Date().getDate() - 29)).Format('yyyy-MM-dd')
        this.listOptionsMap.startDate = last_30day
        this.listOptionsMap.endDate = today
      }
      await this.getList()
    }
  }
</script>

<style lang="less" scoped>
  .intendedPatientList {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .today {
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 12px 16px;
    width: 32%;
    height: 120px;
    background-color: #FFFDFA;;
    border: 1px solid #FFC375;
    border-radius: 6px;
  }

  .today_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .today_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0;
    width: 3px;
    height: 14px;
    background-color: #FF9000;
  }

  .today_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .today_content_line {
    width: 1px;
    height: 40px;
    background-color: #E0E6ED;
  }


  .today_content_item {
    width: 92px;
    color: #252627;
    cursor: pointer;
  }

  .today_content_item.item_active{
    color: #FF9000;
  }

  .today_content_item_num {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }

  .today_content_item_title {
    margin: 12px 0 0 0;
    text-align: center;
    font-size: 14px;
  }

  .history {
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0 0 0 16px;
    padding: 12px 16px;
    height: 120px;
    background-color: #F7FBFF;;
    border: 1px solid #1890FF;
    border-radius: 6px;
  }

  .history_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .history_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0;
    width: 3px;
    height: 14px;
    background-color: #1890FF;
  }

  .history_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .history_content_line {
    width: 1px;
    height: 40px;
    background-color: #E0E6ED;
  }


  .history_content_item {
    width: 116px;
    color: #252627;
    cursor: pointer;
  }

  .history_content_item.item_active{
    color: #1890FF;
  }

  .history_content_item_num {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }

  .history_content_item_title {
    margin: 12px 0 0 0;
    text-align: center;
    font-size: 14px;
  }

  .history_content_converted {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 116px;
    cursor: pointer;
  }

  .history_converted_info{
    color: #252627;
  }

  .history_converted_info.item_active{
    color: #1890FF;
  }

  .history_converted_info_num {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    white-space: nowrap;
  }

  .history_converted_info_title {
    margin: 12px 0 0 0;
    text-align: center;
    font-size: 14px;
  }

  .history_converted_progress {
    --percentage: 0;
    --size: 60px;
    --border-width: 10px;

    position: relative;
    z-index: 1;
    margin: 0 0 0 12px;
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: conic-gradient(#1890FF calc(var(--percentage) * 1%), #D6E9FB 0);
  }

  .history_converted_progress::before {
    content: '';
    position: absolute;
    z-index: 2;
    width: calc(100% - var(--border-width) * 2);
    height: calc(100% - var(--border-width) * 2);
    background: #FFFFFF;
    border-radius: 50%;
  }

  .history_converted_progress_text {
    position: absolute;
    z-index: 3;
    text-align: center;
  }

  .history_converted_progress_text_num {
    font-weight: bold;
    font-size: 14px;
    color: #252627;
  }

  .history_converted_progress_text_name{
    margin: 3px 0 0 0;
    font-size: 10px;
    color: #252627;
  }

  .operation {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .operation_add {
    border-radius: 6px;
  }

  .operation_filter {
    color: #1890FF;
    border-color: #1890FF;
    border-radius: 6px;
  }

  .list {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .list_table {
    width: 100%;
  }

  .table_tag_box {
    margin: 0 0 -8px 0;
  }

  .table_tag {
    margin: 0 8px 8px 0;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px 0 0 0;
  }

  .filterForm_input {
    width: 100%;
  }

  .filterForm_item_dateType /deep/.el-form-item__label, .filterForm_item_dateType /deep/.el-form-item__content{
    line-height: 18px;
  }

  .filterForm_item_dateType /deep/.el-radio input[aria-hidden="true"] {
    display: none !important;
  }

  .filterForm_item_date {
    box-sizing: border-box;
    padding: 8px 8px;
    width: 100%;
    background-color: #F5F7FA;
  }

  /deep/.el-date-editor .el-range__close-icon {
    line-height: 24px;
  }
</style>
